<div class="server-settings-root">
	<h1 style="margin-bottom: 20px;">HaloITSM Settings</h1>
	<form [formGroup]="form">
		<div class="form-group row mb-3">
			<div>
				<input type="checkbox" [formControl]="enabled" />
				<span class="uv-checkbox-label">Enable HaloITSM</span>
			</div>
		</div>
		<div class="mb-3 row" [ngClass]="{'has-error':form.hasError('noneOrAllSettings') && !serverURL.value}">
			<span class="col-lg-2">Server URL:</span>
			<div class="col-lg-5">
				<input class="form-control" type="text" [formControl]="serverURL" />
			</div>
		</div>
		<div class="mb-3 row" [ngClass]="{'has-error':form.hasError('noneOrAllSettings') && !apiUsername.value}">
			<span class="col-lg-2">API Username:</span>
			<div class="col-lg-5">
				<input class="form-control" type="text" [formControl]="apiUsername" (keydown)="onUsernameKeyDownHandler($event)" />
			</div>
		</div>
		<div class="mb-3 row" [ngClass]="{'has-error':form.hasError('noneOrAllSettings') && !apiPassword.value}">
			<span class="col-lg-2">API Password:</span>
			<div class="col-lg-5">
				<input class="form-control" type="password" [formControl]="apiPassword" (keydown)="onPasswordKeyDownHandler($event)" />
			</div>
		</div>
		<div class="mb-3 row" [ngClass]="{'has-error':form.hasError('noneOrAllSettings') && !apiClientId.value}">
			<span class="col-lg-2">API Client ID:</span>
			<div class="col-lg-5">
				<input class="form-control" type="password" [formControl]="apiClientId" (keydown)="onClientIdKeyDownHandler($event)" />
			</div>
		</div>
		<div class="mb-3 row">
			<div>
				<input type="checkbox" [formControl]="useMacAddressLookup" />
				<span class="uv-checkbox-label">Use MAC Address Lookup</span>
			</div>
		</div>
		<div class="mb-3 row">
			<div>
				<input type="checkbox" [formControl]="useIpAddressLookup" />
				<span class="uv-checkbox-label">Use IP Address Lookup</span>
			</div>
		</div>
		<div class="halo-default-settings-divider"></div>
		<div class="row" style="padding-top: 10px;">
			<div style="height: 21px; width: 250px;">
				<button pButton (click)="onSave()" [disabled]="!form.dirty" label="Save Halo Default Settings"></button>
			</div>
			<div style="height: 21px; width: 250px;">
				<button pButton (click)="testConnection()" [disabled]="!enableTestHaloButton" title="Test/Verify Halo connection credentials" label="Test Halo Connection"></button>
			</div>
		</div>
		<div class="halo-default-settings-divider"></div>
	</form>
</div>